/** @jsxImportSource @emotion/react */
import React from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';
import { ADMIN_PATH } from '@constant/admin/route-path';
import AuthGuard from '@component/admin/auth-guard';
import Signin from '@page/admin/signin';
import StudentListPage from '@page/admin/student-page';
import ExpressionListPage from '@page/admin/expression-page';
import ExpressionDetailPage from '@page/admin/expression-page/detail';
import ClozeListPage from '@page/admin/cloze-page';
import VocabularyBookListPage from '@page/admin/vocabulary-book-page';

const withGuard = (node: React.ReactNode) => <AuthGuard>{node}</AuthGuard>;

const AdminApp: React.FC = () => {
  return (
    <Routes>
      <Route path={ADMIN_PATH.SIGNIN_PATH} element={<Signin />} />
      <Route
        path={ADMIN_PATH.HUB_PATH}
        element={withGuard(<Navigate to={ADMIN_PATH.STUDENT_LIST_PATH} replace />)}
      />
      <Route path={ADMIN_PATH.STUDENT_LIST_PATH} element={withGuard(<StudentListPage />)} />
      <Route path={ADMIN_PATH.EXPRESSION_LIST_PATH} element={withGuard(<ExpressionListPage />)} />
      <Route path={ADMIN_PATH.EXPRESSION_DETAIL_PATH} element={withGuard(<ExpressionDetailPage />)} />
      <Route path={ADMIN_PATH.CLOZE_LIST_PATH} element={withGuard(<ClozeListPage />)} />
      <Route path={ADMIN_PATH.VOCABULARY_BOOK_LIST_PATH} element={withGuard(<VocabularyBookListPage />)} />
      <Route path='*' element={<Navigate to={ADMIN_PATH.STUDENT_LIST_PATH} replace />} />
    </Routes>
  );
};

export default AdminApp;
